import type { FaireProductEntity } from "../../entity_types/product";

export const p_nevyjxf2us: FaireProductEntity = {
  token: "p_nevyjxf2us",
  type: "product",
  name: "Dishwasher Cleaner Tablets | Unscented | 30 & 60 Tablets",
  brandToken: "b_qpbga97kpu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/25d16068c5b466d1e30b2f01c3628ac47639eed0e016a8eb10cbb50b11042840.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c80c3fe1d2444d691ffdaa9a74cd2ddfb9f7865f1520d2862e6877769374bb77.png",
    "https://cdn.faire.com/fastly/7a4b6e306d24457c1d19382c0dee770090fdaf514a2303092dd66e986ba99b48.png",
    "https://cdn.faire.com/fastly/6e7fc31f1f797d8039932d6031bd93b1655955f22c964791ebf52150de648727.png",
    "https://cdn.faire.com/fastly/8a514dcd308c1c6cca1a8fd1713ddea58c09fd045d2ca33cd14fe94053e27623.png",
    "https://cdn.faire.com/fastly/a5e81cbc466df78be14d7addcc916cd04c03b62d4292f628b7264ce595c90afd.png",
  ],
  priceDollars: 15.5,
  description:
    "\n * EFFICIENT CLEANING: Achieve sparkling results with Fomin deodorizer dishwasher cleaner tablets. Formulated with citric acid powder, it effectively eliminates hard water, grime, grease, stains, and more. Say goodbye to gunk spots and foam buildup with ease. \n * COMPREHENSIVE CLEANING TABLETS: Fomin dishwasher cleaner tablets provide thorough deep cleaning for dishes and all internal surfaces of dishwashing supplies including stainless steel tubs and plastic parts like water pumps, and filters. \n * SAFE AND ENVIRONMENTALLY FRIENDLY: Crafted from natural ingredients, our dishwasher cleaning tablets are safe for your family and the planet. \n * EASY TO USE: Simply drop a tablet directly into the main dishwasher dispenser and run your dishwasher as usual.",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:09.114Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
